var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextCirlce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 67,
    viewBox: "0 0 162 67",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.10896 27.1347C11.3191 -4.76682 150.843 -8.08342 160.455 18.92C175.602 61.4756 50.0304 74.57 30.2519 62.6671C29.5194 62.2263 29.4934 61.2307 30.0742 61.3662C80.8868 73.2223 167.255 49.5528 155.571 19.587C143.754 -2.8421 0.661592 -0.498398 4.52946 32.0766C7.07614 53.5247 72.861 65.0691 117.58 52.4162C118.98 52.4954 118.065 53.803 116.604 54.2534C68.6458 67.7887 -5.78061 57.182 1.10896 27.1347Z",
    fill: "#7B61FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextCirlce);
export default __webpack_public_path__ + "static/media/textCirlce.2944ae2480228dcb476119a2c84a1688.svg";
export { ForwardRef as ReactComponent };